
import { Component, Prop, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

import { portal } from '@/helpers/Environment'
import { openEcommNext } from '@/helpers/route'

import { getCartPayload, triggerRemoveFromCartEvent } from '@/checkout/helpers/ga4'
import { deleteCart } from '@/state/Cart'
import { removeFlowTickets, removeTickets } from '@/state/Reserve'
import { CartItem } from '@/store/CartItem'
import store from '@/store/store'

@Component({
  name: 'RemoveCartItemOverlay',
  computed: mapGetters({
    cartItems: 'Cart/cartItems',
  }),
})
export default class extends Vue {
  @Prop({ required: true })
  item: CartItem

  @Prop()
  triggerElement: HTMLElement | null

  processing = false

  cartItems

  confirm() {
    this.processing = true

    const tickets = store.getters['Cart/tickets'] as Ticket[]
    const templates = store.getters['Cart/eventTemplates'] as EventTemplate[]
    const types = store.getters['Cart/ticketTypes'] as TicketType[]
    const groups = store.getters['Cart/ticketGroups'] as TicketGroup[]
    const mods = store.getters['Cart/cartMods'] as CartMod[]

    // Emit before removing items. Removing items removes this component and events from stale/orphaned components are ignored.
    this.$emit('close')
    this.removeItems().then((ticketIDs) => {
      this.processing = false
      const payload = getCartPayload(portal.default_currency_code, ticketIDs, tickets, templates, types, groups, mods)
      triggerRemoveFromCartEvent(payload)

      // TODO Remove this once we have checkout in ecomm-next.
      if (this.item.flowResolutionId) {
        const cartId = store.getters['Cart/cartId']
        // cartId exists when there are still items in the cart. Hand it off to the flow details page so the cart is resumed.
        const url = cartId
          ? `/flows/${this.item.flowDefinitionId}?cartId=${cartId}`
          : `/flows/${this.item.flowDefinitionId}`
        openEcommNext(url)
      }
    })
  }

  cancel() {
    this.$emit('close')
  }

  private removeItems(): Promise<string[]> {
    if (this.item.isDependency || this.cartItems.length === 1) {
      const result = store.getters['Cart/tickets'].map((item) => item.id)
      const cartId = store.getters['Cart/cartId']
      return deleteCart(cartId).then(() => result)
    } else if (this.item.flowResolutionId) {
      const result = this.ticketIds
      return removeFlowTickets(this.item.flowResolutionId).then(() => result)
    } else {
      const result = this.ticketIds
      return removeTickets(this.ticketIds).then(() => result)
    }
  }

  get ticketIds(): string[] {
    return this.item.ticketIds
  }

  get showDependencyWarning() {
    return this.item.isDependency && this.cartItems.length > 1
  }
}
